import * as angular from 'angular';
import { ChartDirectiveBase } from './ChartDirectiveBase';
import { StatusChartMode, StatusChart, StatusChartOptions, SvgManager } from '../../../charting';
import { IDynamicCompileService } from '../../services/dynamicCompileService';
import { ChartOptions, Margins } from '../../../models';

export interface IStatusChartDirective extends angular.IDirective {
}

export interface IStatusChartDirectiveScope extends angular.IScope {
    data: any[];
    id: string;
    mode: StatusChartMode;
    options?: StatusChartOptions;
    ratio?: number;
    series?: any[];
}

export class StatusChartDirective extends ChartDirectiveBase implements IStatusChartDirective {
    static directiveId = 'wtStatusChart';

    constructor(private _dynamicCompileService: IDynamicCompileService) {
        super();
        this.scope = {
            data: '=',
            mode: '=',
            options: '=?',
            ratio: '<?'
        };
        this.link.bind(this);
    }

    link = ($scope: IStatusChartDirectiveScope, element: angular.IAugmentedJQuery, attrs, _controller) => {
        if (!attrs.id) {
            console.error('Using a chart directive requires that an id is set to the directive.');
        } else {
            const containerName = attrs.id;
            element.attr('id', containerName);
            if (!$scope.options) {
                $scope.options = {} as StatusChartOptions;
            }
            const margins = new Margins(0, 0, 10, 0);
            const chartOptions = new ChartOptions(60, 10, 0, 60);
            const svgManager = new SvgManager(containerName, margins);
            const chart = new StatusChart(chartOptions, svgManager);
            this.initWatchers($scope, chart, element, margins, svgManager);

            chart.onDateChanged((date: Date) => {
                $scope.options.crosshairDate = date;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });
        }
    }

    private initWatchers($scope: IStatusChartDirectiveScope, chart: StatusChart, element: angular.IAugmentedJQuery, margins: Margins, svgManager: SvgManager) {
        $scope.$watch(() => $scope.data, () => {
            if ($scope.data) {
                chart.update($scope.data);
                $scope.series = $scope.data;
                this._dynamicCompileService.compileGroup(element, <any>$scope);
            }
        });
        $scope.$watch(() => $scope.mode, (newValue) => {
            if (newValue || newValue === 0) {
                chart.mode(newValue);
            }
        });
        $scope.$watch(() => $scope.options.crosshairDate, (newValue) => {
            chart.updateCrosshair(newValue);
        });
        $scope.$watch(() => $scope.options.isLegendVisible, () => {
            chart.isLegendVisible(!!$scope.options.isLegendVisible);
            chart.update($scope.data ?? []);
        });

        $scope.$watch(() => $scope.ratio, () => {
            if ($scope.ratio) {
                const { ratio } = $scope;
                const newMargins = Object.assign({}, margins);
                Object.keys(newMargins)
                    .forEach(key => newMargins[key] = newMargins[key] * ratio);
                svgManager.margins(newMargins);
                chart.ratio(ratio);
            }
        });
    }
}